import React, { useEffect, useState } from 'react';

import lodash from 'lodash';

import { Box, Stack, useMediaQuery, useTheme } from '@mui/material';

import CompanyInfoForm from './components/CompanyInfoForm';
import { useCompanyForm } from './components/CompanyInfoForm/useCompanyForm';

const CompanyData: React.FC = () => {
  const muiTheme = useTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(muiTheme.breakpoints.down('md'));

  const {
    control,
    handleSubmit,
    errors,
    onSubmit,
    watch,
    loading: loadingCompanyForm,
    selectedCompany,
  } = useCompanyForm();

  const formValues = watch();
  const [isEdited, setIsEdited] = useState(false);

  const debouncedSubmit = lodash.debounce(values => {
    if (isEdited) {
      handleSubmit(() => onSubmit(values))();
      setIsEdited(false);
    }
  }, 3000);

  useEffect(() => {
    if (isEdited) {
      debouncedSubmit(formValues);
    }

    return () => {
      debouncedSubmit.cancel();
    };
  }, [formValues, isEdited]);

  const handleFieldChange = () => {
    setIsEdited(true);
  };

  return (
    <Stack
      direction="column"
      spacing={isMobile ? 1 : 2}
      sx={{
        width: '100%',
        maxWidth: '100%',
        overflow: 'hidden',
      }}
    >
      <Box>
        <CompanyInfoForm />
      </Box>
    </Stack>
  );
};

export default CompanyData;
